import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

import type { SuitabilityLetterResponse } from '../types';

export function clientCaseSuitabilityLetterApi(path: string) {
  return {
    path,
    // Craig §3: attaches the APPROVED letter to the recommendation pack as a
    // PDF document (below the cover note). The server renders the immutable
    // approved snapshot (approved_body) — 422 if the letter is unapproved or
    // the case has no documents pack. Responds 201 with the created Document.
    attachToPack: () => ({
      path: `${path}/attach-to-pack`,
      POST: () =>
        api.post<JsonApiResponseSingle>(`${path}/attach-to-pack`, undefined, {
          // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
          skipRedirect: true,
        }),
    }),
    // The single human-in-the-loop gate (SM&CR / Consumer Duty): records the
    // named adviser + timestamp against the draft. It does NOT transmit
    // anything — delivery rides the existing "Send Recommendation Pack" path.
    // 422 if the draft is not yet `completed`.
    approve: () => ({
      path: `${path}/approve`,
      // Sends the exact adviser-approved text so the server can snapshot it
      // (approved_body + SHA256). The backend `requires :body` — a bodyless PUT
      // 400s — so the caller MUST thread the edited text through.
      PUT: (body: string) =>
        api.put<SuitabilityLetterResponse>(
          `${path}/approve`,
          { body },
          {
            // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
            skipRedirect: true,
          }
        ),
    }),
  };
}
